(function($, exports) {

	exports.init = function() {
		var $toggle = $('.b-toggle-text__toggle');

		$toggle.on('click', function() {
			var $rest = $(this).closest('.container-xs').find('.b-toggle-text__rest');
			$(this).toggleClass('is-active');
			$rest.slideToggle();
		});

	};
	
})(jQuery, this.TOGGLETEXT = {});